import {createStyles} from '@material-ui/core';

const style = createStyles({
  button__icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    marginRight: '2px',
  },
  icon__svg: {
    fill: '#fff',
    width: '20px',
    height: '20px',
  },
});

export default style;
